module.exports = __webpack_public_path__ + "img/img02.ea2b0c0c.jpg";